module.exports = __webpack_public_path__ + "static/logo_oms_white.1e1a47a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_oms_white.png
// module id = 360
// module chunks = 95715928098905 114276838955818